var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from "aurelia-framework";
import { BaseAgentWinningClaims } from "../../base-agent-winning-claims";
import { Router } from "aurelia-router";
import { ClientLotteryClientService } from "../../../../../services/modules/client/client-lottery-client-service";
import { TokenClient } from "../../../../../services/authentication/token-client.service";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { DialogClientService } from "../../../../../services/basics/dialog-client.service";
import { I18N } from "aurelia-i18n";
import { LookupClientService } from "../../../../../services/lookups/lookup-client.service";
import { EventAggregator } from "aurelia-event-aggregator";
var AgentWinningClaims = /** @class */ (function (_super) {
    __extends(AgentWinningClaims, _super);
    function AgentWinningClaims(eventAggrigator, router, lotteryClientService, tokenClient, i18N, dialogClientService, notificationClientService, lookupClientService) {
        return _super.call(this, eventAggrigator, router, lotteryClientService, tokenClient, i18N, dialogClientService, notificationClientService, lookupClientService) || this;
    }
    AgentWinningClaims = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [EventAggregator, Router, ClientLotteryClientService, TokenClient,
            I18N, DialogClientService, NotificationClientService, LookupClientService])
    ], AgentWinningClaims);
    return AgentWinningClaims;
}(BaseAgentWinningClaims));
export { AgentWinningClaims };
